import { COLORS } from '@constants';
import { DETAILIZATION_TAB_KEYS } from '../../../constants';

const LabelPluginConstants = {
    style: {
        font: '12px sans-serif',
        textAlign: 'center'
    },
    labelId: 'monthLabels'
};

export function getMonthSubLabelsPluginConfig(detailizationTab, chartDatasets) {
    return {
        id: LabelPluginConstants.labelId,
        afterDraw(chart) {
            if (detailizationTab === DETAILIZATION_TAB_KEYS.MONTHS) return;

            const dates = chartDatasets[0]?.dates;
            if (!dates?.length) return;

            const xScale = chart.scales.x;
            const { ctx } = chart;

            ctx.save();
            ctx.font = LabelPluginConstants.style.font;
            ctx.fillStyle = COLORS.$gray60Black;
            ctx.textAlign = LabelPluginConstants.style.textAlign;

            const seenMonths = new Set();

            xScale.ticks.forEach((tick) => {
                const dateString = dates[tick.value];
                if (!dateString) return;

                const dateParts = dateString.split(' ');
                const month = dateParts[1];
                const monthKey = `${dateParts[1]} ${dateParts[2]}`;
                if (!seenMonths.has(monthKey)) {
                    seenMonths.add(monthKey);
                    const x = xScale.getPixelForValue(tick.value);
                    const y = xScale.bottom + 14;
                    ctx.fillText(month, x, y);
                }
            });

            ctx.restore();
        }
    };
}
